import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { cn } from '../utils/cn';

const TitleWithIcon = ({ title, handler, children, Icon = AddIcon, containerStyle, titleStyle, buttonStyle }) => {
  return (
    <div className={cn('flex items-center gap-x-4 my-4', containerStyle)}>
      <p className={cn('truncate text-2xl sm:text-3xl font-normal', titleStyle)}>{title}</p>
      {handler && (
        <button
          onClick={handler}
          type="button"
          className={cn('flex items-center justify-center cursor-pointer bg-orange-500 hover:bg-orange-600 rounded-full p-2', buttonStyle)}>
          <Icon className="text-white" />
        </button>
      )}
      {children && children}
    </div>
  );
};
export default TitleWithIcon;
